import { render, staticRenderFns } from "./DatosFacturacion.vue?vue&type=template&id=4a443c7d&scoped=true"
import script from "./DatosFacturacion.vue?vue&type=script&lang=js"
export * from "./DatosFacturacion.vue?vue&type=script&lang=js"
import style0 from "./DatosFacturacion.vue?vue&type=style&index=0&id=4a443c7d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a443c7d",
  null
  
)

export default component.exports